<template>
  <div class="side-info-container">
    <div class="side-info" style="top: 132px; left:0;">
      <p>
        Votre message, d’une durée de 6 secondes, sera intégré dans chaque boucle. Il sera diffusé 500 fois par jour, soit 1 fois toutes les boucles.
      </p>
      <p>
        Attention, un certain nombre de produits sont soumis à une législation stricte et nécessitent l'intégration de mentions légales et sanitaires sur une surface représentant au moins 20% du visuel. Vous êtes tenus de connaître et respecter les lois en vigueur, notamment pour la publicité concernant l’alcool, le tabac, les jeux d'argent et l'alimentation.
      </p>
      <router-link to="/miscellanous/mentions-legales" id="mentions-legales" class="btn btn-default btn-side-info">
        CONSULTER LES MENTIONS OBLIGATOIRES
      </router-link>
    </div>
    <svg class="oblique-side-bar-left" data-name="oblique" xmlns="http://www.w3.org/2000/svg" width="577" height="1460.4" viewBox="0 0 577 1460.4">
      <defs>

        <linearGradient id="side-info-gradient" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" :stop-color="gradientColor"/>
          <stop offset="55%" stop-color="black" stop-opacity="0"/>
        </linearGradient>

        <pattern id="side-info-background" patternUnits="userSpaceOnUse" width="1000" height="2500">
          <image class="trad-features" :href="background" :x="left" :y="top" :width="size" :height="size" />
        </pattern>

      </defs>

      <title>side-info</title>

      <clipPath id="myClip">
        <polygon transform="translate(30,-200)" points="577 1460.4 0 1460.4 0 0 330.7 0 577 1460.4" />
      </clipPath>

      <g clip-path="url(#myClip)">
        <rect x="0" y="0" width="600" height="2000" class="trad-features" fill="url(#side-info-background)"/>
        <rect x="0" y="0" width="600" height="2000" class="trad-features" fill="url(#side-info-gradient)"/>
      </g>

    </svg>
  </div>
</template>

<script>
  
  const AppModules = require('annonces-app-modules')(process.env.APP_NAME, process.env.NODE_ENV)

  export default {
    props: ['template'],
    data () {
      return {
        user: AppModules.getUser(),
        background: null,
        size: null,
        left: null,
        top: null,
        gradientColor: null
      }
    },
    mounted: function () {
      return this.user.getProperties((err, userProps) => {
        if (err) {
          console.log(err)
        }

        this.sideBarStyle(userProps)
      })
    },
    methods: {
      sideBarStyle: function (userProps) {
        /**
         * get commercant side
         * backgroung image
         */

        // determine merchant trade ( trad.| boulangerie | fleuriste )
        this.$commercantTrade = this.$tradeSwitch(userProps)
        console.debug('===> this.$commercantTrade', this.$commercantTrade)

        // get bg config
        this.sideConfig = AppModules.MessageDefinitions[process.env.APP_NAME].sideInfo[this.$commercantTrade]
        console.debug('===> this.sideConfig', this.sideConfig)

        this.background = this.sideConfig.background
        this.size = this.sideConfig.size + '%'
        this.left = this.sideConfig.left
        this.top = this.sideConfig.top
        this.gradientColor = this.sideConfig.gradient.color
      }
    }
  }

</script>

<style type="text/css">

  .side-info-container {
    top: -200px;
    left: -43px;
    position: fixed;
  }

</style>


// WEBPACK FOOTER //
// SideInfo.vue?ef68d444